import React, { Component } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { Button, Glyphicon } from 'react-bootstrap'
import { handleErrorFetchingData } from '../../../../functions/errorHandling'
import getServerURL from '../../../../functions/getServerURL'

class ExportFunctionalGroupsForTraining extends Component {

  state = {
    downloadingFunctionalGroupsForTraining: false
  }

  componentDidMount() {
    this.fetchFunctionalGroups();
  }

  // constructor
  constructor(props) {
    super(props)
    const { training } = this.props
    this.training = training
  }

  fetchFunctionalGroups = () => {
    return axios.get(`${getServerURL()}assignments/get_assignment_details/`, {
      params: { assessment: this.training.assessment_id },
      headers: { "Authorization": `Bearer ${ localStorage.getItem("token") }` }
    });
  }

  downloadFunctionalGroupsForTraining = () => {
    if (this.state.downloadingFunctionalGroupsForTraining) {
      return
    }

    this.setState({ downloadingFunctionalGroupsForTraining: true })

    axios({
      url: `${getServerURL()}export-functional-groups-for-training/`,
      method: 'GET',
      params: {
        'training_id': this.training.id
      },
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("token")
      },
      responseType: 'blob',
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      const date = new Date().toJSON().split("T")[0].split('-')
      const formattedDate = `${date[1]}-${date[2]}-${date[0]}`
      link.setAttribute('download', `${this.training.name}_Groups_${formattedDate}.xlsx`)
      this.setState({ downloadingFunctionalGroupsForTraining: false })
      swal({
        title: "Your file is ready",
        text: "Click the button to download",
        icon: "success",
        button: 'Download'
      })
      .then(() => {
        document.body.appendChild(link)
        link.click()
      })
    })
    .catch(error => {
      const message = "There was an error downloading your file."
      handleErrorFetchingData(error, message)
    })
  }

  handleExportAssignmentMetrics = () => {

    this.fetchFunctionalGroups().then(
      (response) => {
        let assignmentData = response.data[0];
        if (assignmentData && assignmentData.functional_groups && assignmentData.functional_groups.length > 0) {
          this.downloadFunctionalGroupsForTraining();
        }
        else {
          swal({
            title: "No Functional Groups Assigned",
            text: "There are no functional groups assigned to this training.",
            icon: "info",
            button: "OK",
          });
        }
      }
    )
    
  }

  render () {

    const { downloadingFunctionalGroupsForTraining } = this.state

    return (
      <Button
        disabled={downloadingFunctionalGroupsForTraining || !this.training.assessment_id}
        onClick={this.handleExportAssignmentMetrics}
      >
        {downloadingFunctionalGroupsForTraining ?
          <Glyphicon
            glyph='refresh'
            style={{minWidth: '170px'}}
            className='rotate-btn'
          />
          :
          'Export Assigned Groups to Excel'
        }
      </Button>
    )
  }
}

export default ExportFunctionalGroupsForTraining



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/ExportFunctionalGroupsForTraining.js